import React, {Suspense, useEffect} from "react";
import {state,setLoadingProgress} from "../../state";
import {useSnapshot} from "valtio";
import { Html, useProgress } from '@react-three/drei'
// -----------------------------------------------------------
/*
    application type
*/
// for standard type
//import {MemDynamicModelLoader} from "./DynamicModelLoader";
//
//  for modular units
//import ModuleModelLoader from "./ModuleModelLoader";
//
//  for panels units
import PanelsModuleLoader from "./PanelsModuleLoader";
//
// -----------------------------------------------------------


const MultiModelLoader = ({camera}) => {
  const Loader = () => {
    const { progress } = useProgress()
    useEffect(()=>{
      setLoadingProgress(progress);
    },[progress])
    return null
  }

  const {getCurrModels, folderLocation, fileFormat} = useSnapshot(state);
  
  return (
    <>
      {getCurrModels.map((item, index) => {

        return (
          <Suspense key={index} fallback={<Loader/>  }>
            <PanelsModuleLoader key={index} camera={camera} modelRef={item} fileFormat={fileFormat} location={folderLocation}/>
          </Suspense>
        )
      })}
    </>
  );
}

export default MultiModelLoader;
